module.exports = __webpack_public_path__ + "static/media/md-female.01eebeb5.svg";